import React, { PureComponent } from 'react';
import ChapterLevelContent from '../../../../treeComponents/component/ChapterLevelContent';
import { PhaseNode, WeekNode, ChapterNode, ConceptNode } from './index';
import PreviewTest from './PreviewTest';
import { getPropertyValue } from '../../../../../../../utils';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

interface PreviewTreeProps {
  treeNode: any;
  level: number;
  subjectTab: string;
  phaseIndex: number;
  packageEndDate: string | Date;
  childIndex:number;
  viewPlanData:any;
  showTestVisibility?: boolean;
  activeCoursePlanViewList?: any[];
}

interface PreviewTreeState {
  isExpanded: boolean;
}

class PreviewTree extends PureComponent<PreviewTreeProps, PreviewTreeState> {
  constructor(props: PreviewTreeProps) {
    super(props);
    this.state = { isExpanded: false };
  }

  componentDidMount(): void {
    this.setState({ isExpanded: (this.props.activeCoursePlanViewList || []).includes(this.props.treeNode.key) });
  }
  componentDidUpdate(prevProps: Readonly<PreviewTreeProps>, prevState: Readonly<PreviewTreeState>, prevContext: any): void {
    if (this.props.activeCoursePlanViewList !== prevProps.activeCoursePlanViewList) {
      this.setState({ isExpanded: (this.props.activeCoursePlanViewList || []).includes(this.props.treeNode.key) });
    }
  }

  handleExpandNode = () => this.setState({ isExpanded: !this.state.isExpanded });

  hasValidChildren = () => this.props.treeNode.children && this.props.treeNode.children.length > 0;

  renderNode = () => {
    const { subjectTab, treeNode,childIndex,viewPlanData } = this.props;
    const { isExpanded } = this.state;
    const { key } = treeNode;
    switch (key) {
      case 'phase':
        let hasValidSubjects =
          subjectTab === 'All Subjects' ||
          treeNode.subjects.filter((subject: any) => subject.name.toLowerCase() === subjectTab.toLowerCase() && subject.chapterCount > 0).length;
        if (hasValidSubjects)
          return (
            <>
              <PhaseNode
                subjectTab={subjectTab}
                data={treeNode}
                handleExpandNode={this.handleExpandNode}
                isExpanded={isExpanded}
                viewPlanData={viewPlanData}
              />
            </>
          );
        break;
      case 'week':
        hasValidSubjects =
          subjectTab === 'All Subjects' ||
          treeNode.subjects.filter((subject: any) => subject.name.toLowerCase() === subjectTab.toLowerCase()).length;
        if (hasValidSubjects)
          return (
            <>
              <WeekNode subjectTab={subjectTab} data={treeNode} handleExpandNode={this.handleExpandNode} isExpanded={isExpanded} viewPlanData={viewPlanData} />
            </>
          );
        break;
      case 'chapter':
        const hasValidChapters =
          subjectTab === 'All Subjects' || treeNode.subjectName.toLowerCase() === subjectTab.toLowerCase();
        if (hasValidChapters) {
          return (
            <>
              <ChapterNode subjectTab={subjectTab} data={treeNode} handleExpandNode={this.handleExpandNode} isExpanded={isExpanded} />
            </>
          );
        }
        break;
      case 'concept':
        return <ConceptNode data={treeNode} 
                subjectTab={subjectTab}
                childIndex={childIndex} 
        />;
      default:
        return <h4>...Adding Components soon</h4>;
    }
  };
  getPadding = () => {
    const { treeNode, level } = this.props;
    switch (treeNode.key) {
      case 'phase':
        return `20px 2%`;
      case 'week':
        return `22px 4%`;
      case 'chapter':
        return `22px 6% 22px 5%`;
      case 'concept':
        return `7px 3% 7px 6%`;
      default:
        return `1%`;
    }
  };
  render = () => {
    const { treeNode, level, subjectTab, phaseIndex, packageEndDate, viewPlanData, showTestVisibility, activeCoursePlanViewList } = this.props;
    return (
      <div
        style={{
          width: '100%',
        }}
      >
        <div
          style={{
            borderBottom: '1px solid lightgrey',
            padding:this.getPadding(),
          }}
        >
          {this.renderNode()}
        </div>
        {this.state.isExpanded &&
          this.hasValidChildren() &&
          treeNode.children.map((child: any,index:number) => {
          return(   
             subjectTab === 'All Subjects' || child.subjectName === subjectTab || ( child.key !== "chapter" && child.key !== "concept") ?
              <>
                <PreviewTree 
                 key={child.name} 
                 subjectTab={subjectTab} 
                 treeNode={child} level={level * 2} 
                 phaseIndex={phaseIndex} 
                 packageEndDate={packageEndDate} 
                 childIndex={index}
                 viewPlanData={viewPlanData}
                 showTestVisibility={showTestVisibility}
                 activeCoursePlanViewList={activeCoursePlanViewList}
                 />

                {/* {child.hasOwnProperty('weekNo') && child.content && child.content.length ? (
                  child.content.map((test: any) => {
                    return <PreviewTest test={test} isWeek={true} />;
                  })
                ) : (
                  <></>
                )} */}
              </>
            :
            <></>
          )
          })}
              {this.state.isExpanded && treeNode.conceptContent &&
                 <ChapterLevelContent
                      isChapterLevel={false}
                      conceptPhaseData={treeNode}
                      subjectTab={subjectTab}
                      levelContent={treeNode.conceptContent}
                      isPreviewScreen={true}
                      // mappedConceptsAndChapter={mappedConceptsAndChapter}
                    />
              }
              {this.state.isExpanded && treeNode.chapterContent &&
                 <ChapterLevelContent
                      isChapterLevel={true}
                      conceptPhaseData={treeNode}
                      subjectTab={subjectTab}
                      levelContent={treeNode.chapterContent}
                      isPreviewScreen={true}
                      // mappedConceptsAndChapter={mappedConceptsAndChapter}
                    />
              }
          {
            this.state.isExpanded && treeNode.content && treeNode.content.length ? (
              treeNode.content.map((test: any, index: number) => (
                  <PreviewTest showTestVisibility={showTestVisibility} test={test} isWeek={true} phase={treeNode} phaseIndex={phaseIndex} packageEndDate={packageEndDate}/>
              ))
            ) : (
                <></>
            )
          }
          
      </div>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    activeCoursePlanViewList: getPropertyValue(state, 'courseMangementData.contentManagementData.activeCoursePlanViewList', []),
  };
};
const mapDispatchToProps = {
};

  export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
  )(PreviewTree);
